module.exports = __webpack_public_path__ + "img/q23.cc8f8f55.jpg";